import { AfterViewInit, Component, ElementRef, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Feature, Map, MapBrowserEvent, Overlay, View } from 'ol';
import { PlazaModel } from 'src/app/core/models/plaza.model';
import { environment } from 'src/environments/environment';
import { get as getProjection } from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import { Cluster, XYZ } from 'ol/source';
import * as Proj from 'ol/proj';
import { defaults as defaultControls } from 'ol/control';
import Geometry from 'ol/geom/Geometry';
import Layer from 'ol/layer/Layer';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Polygon from 'ol/geom/Polygon';
import { GeoJSON } from 'ol/format';
import { Circle, Fill, Icon, Stroke, Style } from 'ol/style';
import { LocalizacionModel } from 'src/app/core/models/localizacion.model';
import Draw, { DrawEvent } from 'ol/interaction/Draw';
import Modify, { ModifyEvent } from 'ol/interaction/Modify';
import Snap from 'ol/interaction/Snap';
import Point from 'ol/geom/Point';
import GeometryType from 'ol/geom/GeometryType';
import { TranslateService } from '@ngx-translate/core';
import IconAnchorUnits from 'ol/style/IconAnchorUnits';
import * as olExtent from 'ol/extent';
import * as textStyle from 'ol/style/Text';
import * as observable_export from 'ol/Observable';
import MultiPoint from 'ol/geom/MultiPoint';
import {
  platformModifierKeyOnly,
  altKeyOnly,
  shiftKeyOnly,
  altShiftKeysOnly,
  click,
  singleClick,
  pointerMove
} from 'ol/events/condition';

const observable = observable_export as any;

const EDIT_ADD = 'add';
const EDIT_MODIFY = 'modify';
const EDIT_DELETEVERTEX = 'deleteVertex';
const EDIT_REMOVE = 'remove';

const DEFAULT_ZOOM_LEVEL = 15;
const MAX_ZOOM_LEVEL = 25;
const DEFAULT_EXTENT_PADDING = 30;
const DEFAULT_ANIMATION_MILLISECONDS = 500;
const MAX_RESOLUTION = 0.29858214173896974;
const CLUSTER_PIXEL_DISTANCE = 38;

@Component({
  selector: 'dum-ol-map-zona-vigilancia',
  templateUrl: './ol-map-zona-vigilancia.component.html',
  styleUrls: ['./ol-map-zona-vigilancia.component.scss']
})
export class OlMapZonaVigilanciaComponent implements OnInit, AfterViewInit {

  @Input() width?: string | number = environment.default_width_map;
  @Input() height?: string | number = environment.default_height_map;
  @Input() plazas?: PlazaModel[] = [];
  @Input() poligono: LocalizacionModel[] = [];
  @Input() lat: number = environment.default_lat_map;
  @Input() lon: number = environment.default_lon_map;
  @Output() newPolygonEvent: EventEmitter<LocalizacionModel[]> = new EventEmitter<LocalizacionModel[]>();
  zoom: number = 13;
  mapEl: HTMLElement;
  target: string = 'map-' + Math.random().toString(36).substring(2);
  map: Map;
  draw: Draw;
  modify: Modify;
  snapPolygon: Snap;
  snapPoints: Snap;
  deletevertex: Modify;
  polygonLayer: VectorLayer;
  iconLayer: VectorLayer;
  containerPopUp;
  contentPopup;
  overlayPopUp: Overlay;

  itemTools = [
    {
      label: `${this.translateService.instant('GLOBAL.MAPTOOLBAR.EDIT_ADD')}`,
      active: false,
      type: EDIT_ADD,
      icon: 'pi-plus'
    }, {
      label: `${this.translateService.instant('GLOBAL.MAPTOOLBAR.EDIT_MODIFY')}`,
      active: false,
      type: EDIT_MODIFY,
      icon: 'pi-pencil'
    }, {
      label: `${this.translateService.instant('GLOBAL.MAPTOOLBAR.EDIT_DELETEVERTEX')}`,
      active: false,
      type: EDIT_DELETEVERTEX,
      icon: 'pi-times'
    }, {
      label: `${this.translateService.instant('GLOBAL.MAPTOOLBAR.EDIT_REMOVE')}`,
      active: false,
      type: EDIT_REMOVE,
      icon: 'pi-times-circle'
    }
  ];

  constructor(private elementRef: ElementRef, private translateService: TranslateService) { }

  ngAfterViewInit(): void {
    this.containerPopUp = document.getElementById('popup-zonas');
    this.contentPopup = document.getElementById('popup-zonas-content');
    this.mapEl = this.elementRef.nativeElement.querySelector('#' + this.target);
    this.setSize();
    this.overlayPopUp = new Overlay({
      element: this.containerPopUp,
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });
    this.map = new Map({
      target: this.target,
      layers: [
        new TileLayer({
          source: new XYZ({
            attributions:
              'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/' +
              'rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
            url:
              'https://server.arcgisonline.com/ArcGIS/rest/services/' +
              'World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
          }),
        })
      ],
      overlays: [this.overlayPopUp],
      view: new View({
        projection: getProjection('EPSG:3857'),
        center: Proj.fromLonLat([this.lon, this.lat]),
        zoom: this.zoom,
        maxZoom: 19
      }),
      controls: defaultControls({ attribution: false, zoom: false }).extend([]),
    });
    this.loadPolygon();
    this.loadIcons();
    this.setClickEventPlazaMarker();
  }

  ngOnInit(): void {
  }

  protected polygonStyleFunction(feature: Feature, resolution) {
    const image = new Circle({
      radius: 5,
      fill: null,
      stroke: new Stroke({ color: 'orange', width: 2 })
    });
    const image2 = new Circle({
      radius: 5,
      fill: new Fill({
        color: 'orange',
      }),
      stroke: new Stroke({
        color: [255, 255, 255, 0.75],
        width: 1.5,
      })
    });
    const geometryFunction = (feat: Feature) => {
      const geomCoords = (feat.getGeometry() as any).getCoordinates();
      if (Array.isArray(geomCoords[0])) {
        const totalGeoArray = [];
        geomCoords.forEach(geomArray => {
          const coordinates = (Array.isArray(geomArray[0][0])) ?
            [].concat.apply([], geomArray) :
            geomArray;
          coordinates.forEach(coordspair => {
            totalGeoArray.push(coordspair);
          });
        });
        return new MultiPoint(totalGeoArray);
      } else {
        return feat.getGeometry();
      }
    };
    return [
      new Style({
        image: (feature.getGeometry().getType() === GeometryType.POINT) ? image2 : image,
        geometry: geometryFunction
      }),
      new Style({
        stroke: new Stroke({
          color: 'rgba(0, 0, 255, 0.7)',
          width: 3,
        }),
        fill: new Fill({
          color: 'rgba(0, 0, 255, 0.1)'
        })
      })
    ];
    /*const stylesPolygon: any[] = [
      new Style({
        stroke: new Stroke({
          color: 'blue',
          width: 3,
        }),
        fill: new Fill({
          color: 'rgba(0, 0, 255, 0.1)',
        }),
      }),
    ];
    return stylesPolygon;*/
  }

  protected vectorStyleFunction(feature: Feature, resolution) {
    let style;
    const size = feature.get('features').length;
    if (size === 1) {
      style = new Style({
        image: new Icon({
          anchor: [0.5, 0.5],
          src: this.getIconPlaza(feature.get('features')[0]),
          scale: 0.5,
        })
      });
    } else {
      style = new Style({
        image: new Icon({
          anchorXUnits: IconAnchorUnits.FRACTION,
          anchorYUnits: IconAnchorUnits.FRACTION,
          anchor: [0.5, 0.5],
          src: environment.icon_map.cluster,
          scale: 1,
        }),
        text: new textStyle.default({
          text: size.toString(),
          offsetY: -2,
          stroke: new Stroke({
            color: '#fff',
            width: 1
          }),
          textBaseline: 'middle',
          font: '12px Calibri,sans-serif',
          textAlign: 'center',
          fill: new Fill({
            color: '#fff'
          })
        })
      });
    }
    return style;
  }

  loadIcons() {
    const markers: Feature[] = [];
    this.plazas.forEach((plaza) => {
      markers.push(new Feature({
        plaza: true,
        estadoPlaza_id: plaza.estadoPlaza.id,
        tipoPlaza_id: plaza.tipoPlaza.id,
        geometry: new Point(Proj.fromLonLat([plaza.localizacion.coordinates[1], plaza.localizacion.coordinates[0]])),
        calle: plaza.calle,
        numero: plaza.numero,
        ocupacion: plaza.estadoPlaza.nombre,
        tipoAparcamiento: plaza.tipoAparcamiento ? plaza.tipoAparcamiento.nombre : null,
        tipoPlaza: plaza.tipoPlaza.nombre,
        coordinate: plaza.localizacion.coordinates,
      }));
    });
    const styleFunction = (feature: Feature, resolution) => this.vectorStyleFunction(feature, resolution);
    this.iconLayer = new VectorLayer({
      source: new Cluster({
        distance: CLUSTER_PIXEL_DISTANCE,
        source: new VectorSource({
          features: markers
        })
      }),
      style: styleFunction
    });
    this.map.addLayer(this.iconLayer);
  }

  public setClickEventPlazaMarker() {
    this.map.on('pointermove', (evt) => {
      const hit = this.map.forEachFeatureAtPixel(evt.pixel, (feature: Feature) => {
        return (feature && (feature.get('features')));
      });
      if (hit) {
        this.map.getTargetElement().style.cursor = 'pointer';
      } else {
        this.map.getTargetElement().style.cursor = '';
      }
    });
    this.map.on('singleclick', (evt) => {
      this.displayInfoPlaza(evt);
    });
  }

  protected getHitCoordinates(coord, geom: Geometry) {
    if (geom.getType() && geom.getType().indexOf('LineString') > -1) {
      return geom.getClosestPoint(coord);
    } else {
      return olExtent.getCenter(geom.getExtent());
    }
  }

  protected isClusterFeature(feature: Feature) {
    return feature && feature.get('features') && feature.get('features').length > 1;
  }

  protected fitExtent(extent: olExtent.Extent,
                      options = {},
                      isCluster = false) {
    if (extent[0] !== Number.POSITIVE_INFINITY) {
      if ((olExtent.getWidth(extent) === 0) &&
        (olExtent.getHeight(extent) === 0)) {
        this.map.getView().setCenter([extent[0], extent[1]]);
        this.map.getView().setZoom((isCluster) ? MAX_ZOOM_LEVEL : 10 || DEFAULT_ZOOM_LEVEL);
      } else {
        setTimeout(() => {
          this.map.getView().fit(extent,
            {
              ...options,
              ...{
                size: [this.mapEl.clientWidth, this.mapEl.clientHeight],
                padding: [DEFAULT_EXTENT_PADDING,
                  DEFAULT_EXTENT_PADDING,
                  DEFAULT_EXTENT_PADDING,
                  DEFAULT_EXTENT_PADDING]
              }
            });
        }, 0);
      }
    }
  }

  protected isEmptyExtent(extent: olExtent.Extent): boolean {
    const wpixels = olExtent.getWidth(extent) / MAX_RESOLUTION;
    const hpixels = olExtent.getHeight(extent) / MAX_RESOLUTION;
    return (wpixels < CLUSTER_PIXEL_DISTANCE) && (hpixels < CLUSTER_PIXEL_DISTANCE);
  }

  private expandClusterFeature(clusterFeature: Feature, evt: MapBrowserEvent) {
    const originalFeatures = clusterFeature.get('features');
    let extent: olExtent.Extent = olExtent.createEmpty();
    originalFeatures.forEach((f: Feature) => {
      extent = olExtent.extend(extent, f.getGeometry().getExtent());
    });
    if (extent[0] !== Number.POSITIVE_INFINITY) {
      if (!this.isEmptyExtent(extent)) {
        this.fitExtent(extent, {
          duration: DEFAULT_ANIMATION_MILLISECONDS
        }, true);
      } else {
        this.showPopup(originalFeatures, evt);
      }
    }
  }

  private displayInfoPlaza = (evt: MapBrowserEvent) => {
    this.map.forEachFeatureAtPixel(evt.pixel, (feature: Feature) => {
      if (feature && (feature.get('features'))) {
        if (this.isClusterFeature(feature)) {
          this.expandClusterFeature(feature, evt);
        } else {
          this.showPopup(feature.get('features'), evt);
        }
      }
    });
  }

  private showPopup(features: Feature[], evt: MapBrowserEvent) {
    const info = [];
    let coordinates = null;
    let existFeature = false;
    let first = true;
    features.forEach((feature: Feature) => {
      if (feature && feature.get('plaza')) {
        if (!first) {
          info.push('<span></span>');
        }
        let infoFranja = '';
        if (feature.get('tipoAparcamiento')) {
          info.push(feature.get('tipoAparcamiento'));
        }
        if (feature.get('calle') && feature.get('numero')) {
          info.push(`<b>Dirección: </b> ${feature.get('calle')}, ${feature.get('numero')}`);
        } else if (feature.get('calle') !== null) {
          info.push(`<b>Dirección :</b> ${feature.get('calle')}`);
        }
        if (feature.get('franjas')) {
          feature.get('franjas').forEach((franja) => {
            infoFranja += `${franja.horaInicio}/${franja.horaFin}<br/>`;
          });
        }
        info.push(`<b>Tipo de plaza : </b>${feature.get('tipoPlaza')}`);
        info.push(`<b>Estado :</b> ${feature.get('ocupacion')}`);

        const timeMax = feature.get('tiempoMaxPermitido') ? `${feature.get('tiempoMaxPermitido')}min` : '';
        info.push(`<b>Tiempo max permitido :</b>${timeMax}`);
        info.push(`<b>PMA :</b>${feature.get('pma') || ''}`);
        info.push(`<b>sector :</b>${feature.get('sector') || ''}`);
        info.push(`<b>Franjas Horarias :</b>${infoFranja}`);

        existFeature = true;
        if (!coordinates) {
          coordinates = this.getHitCoordinates(this.map.getCoordinateFromPixel(evt.pixel), feature.getGeometry());
        }
        first = false;
      }
    });
    if (existFeature) {
      this.contentPopup.innerHTML = info.join('<br/>');
      setTimeout(() => {
        this.overlayPopUp.setOffset([0, -20]);
        this.overlayPopUp.setPosition(coordinates ? coordinates : evt.coordinate);
      }, 0);
    } else {
      this.overlayPopUp.setPosition(undefined);
    }
  }

  closePopUp() {
    this.overlayPopUp.setPosition(undefined);
    return false;
  }

  private addSnapInteractions() {
    this.snapPolygon = new Snap({
      source: this.polygonLayer.getSource(),
    });
    this.map.addInteraction(this.snapPolygon);
    this.snapPoints = new Snap({
      source: this.iconLayer.getSource(),
    });
    this.map.addInteraction(this.snapPoints);
  }

  private addModifyInteraction(isDeleteVertex: boolean) {
    const insertVertexCondition = (e) => {
      return false;
    };
    const deleteCondition = (event) => {
      return singleClick(event);
    };
    const interaction = (isDeleteVertex) ?
      new Modify({
        source: this.polygonLayer.getSource(),
        insertVertexCondition,
        deleteCondition
      }) :
      new Modify({ source: this.polygonLayer.getSource() });
    const modifiedFeatures: Feature[] = [];
    let geometryChangeListener;
    interaction.on('modifystart', (e) => {
      modifiedFeatures.length = 0;
      const features = e.features;
      features.forEach((feature) => {
        geometryChangeListener = feature.getGeometry().on('change', () => {
          const index = modifiedFeatures.indexOf(feature);
          if (index === -1) {
            modifiedFeatures.push(feature);
          }
        });
      });
    });
    interaction.on('modifyend', () => {
      if (geometryChangeListener) {
        observable.unByKey(geometryChangeListener);
        geometryChangeListener = null;
      }
      modifiedFeatures.forEach((feature: Feature) => {
        this.emitPolygon(feature);
      });
      this.iconLayer.getSource().clear();
    });
    this.map.addInteraction(interaction);
    if (isDeleteVertex) {
      this.deletevertex = interaction;
    } else {
      this.modify = interaction;
    }
    this.addSnapInteractions();
  }

  private emitPolygon(feature: Feature) {
    const polygon = [];
    const newPolygon: Polygon = feature.getGeometry() as Polygon;
    newPolygon.getCoordinates().forEach((coordinates) => {
      coordinates.forEach((coordinate) => {
        const localizacion: LocalizacionModel = new LocalizacionModel();
        localizacion.coordinates = Proj.toLonLat(coordinate, 'EPSG:3857');
        localizacion.coordinates = [localizacion.coordinates[1], localizacion.coordinates[0]];
        localizacion.type = 'Point';
        polygon.push(localizacion);
      });
      this.newPolygonEvent.emit(polygon);
    });
  }

  private addInsertInteraction() {
    const vectorSource = new VectorSource({ wrapX: false });
    this.draw = new Draw({
      source: vectorSource,
      type: GeometryType.POLYGON
    });
    this.draw.on('drawend', (result: DrawEvent) => {
      this.emitPolygon(result.feature);
      this.iconLayer.getSource().clear();
      this.polygonLayer.getSource().clear();
      this.polygonLayer.getSource().addFeature(result.feature);
    });
    this.map.addInteraction(this.draw);
    this.addSnapInteractions();
  }

  public loadPolygon() {

    const polygon = [];
    this.poligono.forEach((geometria) => {
      polygon.push(Proj.fromLonLat([geometria.coordinates[1], geometria.coordinates[0]], 'EPSG:3857'));
    });

    const vectorSource = new VectorSource();
    vectorSource.addFeature(new Feature({
      name: 'zona',
      geometry: new Polygon([
        polygon
      ]),
    }));

    const styleFunction = (feature: Feature, resolution) => this.polygonStyleFunction(feature, resolution);
    this.polygonLayer = new VectorLayer({
      source: vectorSource,
      style: styleFunction
    });

    this.map.addLayer(this.polygonLayer);

    const extent: olExtent.Extent = this.polygonLayer.getSource().getExtent();
    if (extent[0] !== Number.POSITIVE_INFINITY) {
      if (!this.isEmptyExtent(extent)) {
        this.fitExtent(extent, {
          duration: DEFAULT_ANIMATION_MILLISECONDS
        }, true);
      }
    }
  }

  private removeInteractions() {
    if (this.draw) {
      this.map.removeInteraction(this.draw);
      this.draw = null;
    }
    if (this.modify) {
      this.map.removeInteraction(this.modify);
      this.modify = null;
    }
    if (this.deletevertex) {
      this.map.removeInteraction(this.deletevertex);
      this.deletevertex = null;
    }
    if (this.snapPolygon) {
      this.map.removeInteraction(this.snapPolygon);
      this.snapPolygon = null;
    }
    if (this.snapPoints) {
      this.map.removeInteraction(this.snapPoints);
      this.snapPoints = null;
    }
  }

  activateItem(item) {
    this.itemTools.forEach((toolItem) => {
      toolItem.active = (toolItem.type === item.type) ? !toolItem.active : false;
    });
    this.removeInteractions();
    if (item.active) {
      if (item.type === EDIT_ADD) {
        this.addInsertInteraction();
      } else if (item.type === EDIT_MODIFY) {
        this.addModifyInteraction(false);
      } else if (item.type === EDIT_DELETEVERTEX) {
        this.addModifyInteraction(true);
      } else if (item.type === EDIT_REMOVE) {
        setTimeout(() => {
          this.polygonLayer.getSource().clear();
          this.newPolygonEvent.emit([]);
          this.iconLayer.getSource().clear();
          item.active = false;
        }, DEFAULT_ANIMATION_MILLISECONDS / 2);
        this.addModifyInteraction(true);
      }
    }
  }

  private setSize() {
    if (this.mapEl) {
      const styles = this.mapEl.style;
      styles.height = coerceCssPixelValue(this.height) || environment.default_height_map;
      styles.width = coerceCssPixelValue(this.width) || environment.default_width_map;
    }
  }

  getIconPlaza(feature: Feature) {
    switch (feature.get('tipoPlaza_id')) {
      case 1:
        if (feature.get('estadoPlaza_id') === environment.estados_plaza.DISPONIBLE) {
          return environment.icon_map.VE.green;
        } else if (feature.get('estadoPlaza_id') === environment.estados_plaza.OCUPADA) {
          return environment.icon_map.VE.red;
        } else if (feature.get('estadoPlaza_id') === environment.estados_plaza.NO_DISPONIBLE) {
          return environment.icon_map.VE.black;
        } else if (feature.get('estadoPlaza_id') === environment.estados_plaza.ALARMA_ACTIVA) {
          return environment.icon_map.VE.blue;
        } else {
          return environment.icon_map.VE.black;
        }
      case 2:
        if (feature.get('estadoPlaza_id') === environment.estados_plaza.DISPONIBLE) {
          return environment.icon_map.PMR.green;
        } else if (feature.get('estadoPlaza_id') === environment.estados_plaza.OCUPADA) {
          return environment.icon_map.PMR.red;
        } else if (feature.get('estadoPlaza_id') === environment.estados_plaza.NO_DISPONIBLE) {
          return environment.icon_map.PMR.black;
        } else if (feature.get('estadoPlaza_id') === environment.estados_plaza.ALARMA_ACTIVA) {
          return environment.icon_map.PMR.blue;
        } else {
          return environment.icon_map.PMR.black;
        }
      case 3:
        if (feature.get('estadoPlaza_id') === environment.estados_plaza.DISPONIBLE) {
          return environment.icon_map.CyD.green;
        } else if (feature.get('estadoPlaza_id') === environment.estados_plaza.OCUPADA) {
          return environment.icon_map.CyD.red;
        } else if (feature.get('estadoPlaza_id') === environment.estados_plaza.NO_DISPONIBLE) {
          return environment.icon_map.CyD.black;
        } else if (feature.get('estadoPlaza_id') === environment.estados_plaza.ALARMA_ACTIVA) {
          return environment.icon_map.CyD.blue;
        } else {
          return environment.icon_map.CyD.black;
        }
      default:
        return environment.icon_map.CyD.black;
    }
  }

}

const cssUnitsPattern = /([A-Za-z%]+)$/;

function coerceCssPixelValue(value: any): string {
  if (value == null) {
    return '';
  }

  return cssUnitsPattern.test(value) ? value : `${value}px`;
}
